<div class="mx-1 mb-1 flex flex-col gap-8">
  <h2 class="font-roboto text-lg font-bold text-neutral-low-pure">
    Últimos dias para preencher!
  </h2>
  <p class="font-roboto text-base font-normal text-neutral-low-pure">
    <strong>Prazo final: {{ limitDate() | date: 'dd/MM' }}</strong
    >. Você tem até essa data para completar todas as informações. Aproveite o
    tempo para revisar com atenção e garantir que tudo esteja correto antes do
    prazo!
  </p>

  <div class="flex justify-between">
    <ui-button
      name="Ver Depois"
      variant="ghost"
      (buttonClick)="handleCloseModal()"
    />
    <ui-button
      name="Ir para área de turmas"
      (buttonClick)="handleSaveAndRedirectButton()"
    />
  </div>
</div>
